import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Button,
    Col,
    Icon,
    PreviewAltCard,
    Row,
} from "../../components/Component";
import { Badge, Form, Modal, ModalBody, ModalHeader, Spinner } from "reactstrap";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { toast } from "react-toastify";
import useLogout from "../../hooks/useLogout";
import { getBookingListAPI } from "../../api/doctor";
import MyButton from "../../MyComp/UI/form/MyButton";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyInput from "../../MyComp/UI/form/MyInput";
import { useNavigate } from "react-router";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import { BASE_URL_IMG } from "../../assets/constants";
import TooltipComponent from "../../components/tooltip/Tooltip";
import { useLocation, } from "react-router";
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem
} from "reactstrap";



const UserConsultations = () => {
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        setError,
        clearErrors,
        getValues,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            isLoading: false,
            data: [],
        },
    });
    const location = useLocation();

    const userId =
        location?.state?.userId ||
        location?.state?.id ||
        localStorage.getItem("userId");

    const [isOpen, setIsOpen] = useState(false);
    const logout = useLogout();
    const isLoading = watch("isLoading");
    const [data, setData] = useState([]);
    const navigate = useNavigate()
    const [imageOpen, setImageOpen] = useState(false);
    const handleImageOpenPreview = (row) => {
        const imageUrl = `${BASE_URL_IMG}${row?.image}`;
        setValue("image_preview", imageUrl);
        setImageOpen(true);
    };
    const [prescriptionUrl, setPrescriptionUrl] = useState(null);
    const [showPrescription, setShowPrescription] = useState(false);

    const openPrescription = (url) => {
        setPrescriptionUrl(`${BASE_URL_IMG}${url}`);
        setShowPrescription(true);
    };

    const closePrescription = () => {
        setShowPrescription(false);
        setPrescriptionUrl(null);
    };



    const [column, setColumn] = useState([
        {
            name: "Appointment No.",
            cell: (row) =>
                row?.appointment_number,
            sortable: false,
        },
        {
            name: "Doctor Name",
            selector: (row) => row?.doctorName,
            cell: (row) => <span className="text-primary" style={{ cursor: "pointer" }} onClick={() => handleShowDoctorsDetails(row)}>{row?.doctorName}</span>,
            sortable: true,
            wrap: true,
        },
        // {
        //   name: "Patient Name",
        //   selector: (row) => row?.patientName,
        //   sortable: true,
        // },
        {
            name: "Patient Name",
            sortable: true,
            wrap: false,
            cell: (row) => {
                const fullAddress = row?.patientName || "";

                return (
                    <div
                        title={fullAddress}   // full text on hover
                        style={{
                            maxWidth: "150px",
                            overflow: "hidden",
                            cursor: "pointer",
                        }}
                    >
                        {truncateByCharacters(fullAddress, 20)}
                    </div>
                );
            },
        },
        {
            name: "Booking Type",
            selector: (row) => row?.booking_type,
            cell: (row) => <span className="text-capitalize"><Badge color={`${row?.booking_type == "online" ? "info" : "gray"}`}>{row?.booking_type}</Badge></span>,
            sortable: true,
        },
        {
            name: "Start Time",
            selector: (row) => row?.start_time,
            sortable: true,
        },
        {
            name: "End Time",
            selector: (row) => row?.end_time,
            sortable: true,
        },
        {
            name: "Status",
            cell: (row) => {
                const statusColorMap = {
                    completed: "success",
                    pending: "warning",
                    upcoming: "info",
                };

                return (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                        }}
                    >
                        {/* Status Badge */}
                        <Badge color={statusColorMap[row?.status]}>
                            {row?.status}
                        </Badge>


                    </div>
                );
            },
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => {
                return (
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                        }}
                    >
                        {row?.prescription_url ? (
                            <>
                                <Button
                                    id={`view-${row?.id}`}   // ✅ IMPORTANT
                                    outline
                                    color="primary"
                                    size="xs"
                                    onClick={() => openPrescription(row.prescription_url)}
                                >
                                    <Icon name="eye" />
                                </Button>

                                <TooltipComponent
                                    direction="top"
                                    id={`view-${row?.id}`}
                                    text="View Prescription"
                                />
                            </>
                        ) : (
                            <span style={{ fontSize: "12px", color: "#999" }} />
                        )}
                    </div>
                );
            },
            sortable: true,
        }

    ]);
    const handleShowDoctorsDetails = (row) => {
        console.log("row", row);
        navigate("/doctorsDetailsView", { state: { doctorId: row?.doctorId, mode: "Approval" } });
    };
    useEffect(() => {
        const body = {
            userId: userId,
        }
        getBookingList(body);
    }, []);
    const getBookingList = (body) => {
        setValue("isLoading", true)
        getBookingListAPI(body)
            .then((res) => {
                if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    toast.clearWaitingQueue();
                    logout();
                } else if (res.data.status === true) {
                    toast.success(res.data.message);
                    toast.clearWaitingQueue();
                    setData(res.data.data);
                    setValue("isLoading", false);
                } else if (res.data.status === false) {
                    setValue("isLoading", false);
                    setData([]);
                    toast.error(!res.data.message);
                    toast.clearWaitingQueue();
                }
            })
            .catch((err) => {
                setValue("isLoading", false);
                toast.error(err?.response?.data?.message);
            });
    };
    const onFormSubmit = (data) => {
        const body = {
            booking_type: watch("booking_type")?.value || "",
            userId: userId,
        }
        getBookingList(body)

    };

    const truncateByCharacters = (text = "", charLimit = 20) => {
        if (!text) return "";

        return text.length > charLimit
            ? text.slice(0, charLimit) + "..."
            : text;
    };

    return (
        <>
            <Head title={"User Consultations List"} />
            <Content>
                <BlockHead size={`sm`}>
                    <BlockBetween>
                        <BlockHeadContent>
                            <BlockTitle page tag="h3">
                                {"User Consultations List"}
                            </BlockTitle>
                        </BlockHeadContent>
                        <BlockHeadContent>
                            <div className="">
                                <Button
                                    color="primary"
                                    outline
                                    className={`  me-n1`}
                                    onClick={() => {
                                        navigate("/users");
                                    }}
                                >
                                    <Icon name={"arrow-left"} />
                                </Button>
                            </div>
                        </BlockHeadContent>
                    </BlockBetween>
                </BlockHead>
                <Block>
                    {isOpen && (
                        <PreviewAltCard>
                            <Form onSubmit={handleSubmit(onFormSubmit)}>
                                <Row>
                                    <Col md={3}>
                                        <MySelect
                                            register={register}
                                            watch={watch}
                                            setValue={setValue}
                                            trigger={trigger}
                                            errors={errors}
                                            title={"Booking Type"}
                                            name={"booking_type"}
                                            placeholder={"Select appointment type"}
                                            options={[
                                                { value: "online", label: "Online" },
                                                { value: "offline", label: "Offline" },
                                            ]}
                                        />

                                    </Col>

                                </Row>
                                <Col md="2" className={`mt-2`}>
                                    <div className="form-group" style={{ marginTop: "31px" }}>
                                        <div className="form-group" style={{ marginTop: "31px" }}>
                                            <Button disabled={isLoading} color="primary" size="md">
                                                {isLoading ? <Spinner size="sm" color="light" /> : "Submit"}
                                            </Button>
                                        </div>
                                    </div>
                                </Col>
                            </Form>
                        </PreviewAltCard>
                    )}
                    <MyDataTable data={data || []} columns={column} title={"Consultations List"} isLoading={isLoading} />
                </Block>
            </Content>
            <Modal isOpen={showPrescription} toggle={closePrescription} size="xl">
                <ModalHeader toggle={closePrescription}>
                    Prescription
                </ModalHeader>

                <ModalBody style={{ height: "80vh", padding: 0 }}>
                    <iframe
                        src={prescriptionUrl}
                        title="Prescription"
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                        }}
                    />
                </ModalBody>
            </Modal>

        </>
    );
};

export default UserConsultations;

